import moment from "moment-timezone";
import React from "react";
import "moment/locale/pt-br";
import { isUrl } from "./helpers";

const auth = require("../services/auth");
moment.tz.setDefault("America/Sao_Paulo");

const dateISO2Front = (date, time = false) => {
  let wrapped = moment(date); //.tz("America/Sao_Paulo");
  if (time) {
    let dtFomated = wrapped.format("DD/MM/YYYY HH:mm:ss");
    return dtFomated;
  } else {
    let dtFomated = wrapped.format("DD/MM/YYYY");
    return dtFomated;
  }
};

export const dateToLongDate = (date) => {
  const dt = new Date(date);

  return new Intl.DateTimeFormat("pt-BR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(dt);
};

export const dateFormatSQLServerToFront = (date) => {
  if (!date || date === "-") return "-";
  let wrapped = moment(date, "YYYY-MM-DD HH:mm:ss");

  let dtFomated = wrapped.format("DD/MM/YYYY HH:mm:ss");
  return dtFomated;
};

export const dateFormat = (date, format = "DD/MM/YYYY") => {
  let wrapped = moment(date); //.tz("America/Sao_Paulo");

  let dtFomated = wrapped.format(format);
  return dtFomated;
};

export const datetime2JS = (str) => {
  const arr = str.split(" ");
  const date = arr[0].split("/");
  const dt = new Date();
  dt.setDate(parseInt(date[0]));
  dt.setMonth(parseInt(date[1]) - 1);
  dt.setFullYear(parseInt(date[2]));
  if (arr[1]) {
    const time = arr[1].split(":");
    dt.setHours(time[0], time[1], time[2], 0);
  } else {
    dt.setHours(0, 0, 0, 0);
  }

  return dt;
};

export const date2Front = (date) => {
  if (date) {
    const formatted = dateISO2Front(date);

    if (formatted.includes("Invalid date") || formatted.includes("Data inválida")) {
      return date;
    }

    return formatted;
  }

  return "-";
};

export const datetime2Front = (date) => {
  if (date) {
    const formatted = dateISO2Front(date, true);
    if (formatted.includes("Invalid date")) {
      return date;
    }
    return formatted;
  }
  return "-";
};

export const datetimeToDate = (date) => {
  if (!date || date === "-") return "-";

  return date.split(" ")[0];
};

export const splitDate = (numberDate) => {
  if (!numberDate || numberDate === "-") return "-";
  const dateStr = numberDate.toString();

  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(4, 6);
  const day = dateStr.substring(6, 8);

  return `${day}/${month}/${year}`;
};

export const convertDatetime = (inputDatetime) => {
  if (!inputDatetime || inputDatetime === "") return "-";
  if (inputDatetime.length <= 7) return inputDatetime;
  const parsedDatetime = moment(datetime2JS(datetimeToDate(inputDatetime)));
  if (parsedDatetime.isValid()) return parsedDatetime.format("DD/MM/YYYY");
  return inputDatetime;
};

export const diffDateTime = (dateTime) => {
  const data = moment(datetime2Front(dateTime), "DD/MM/YYYY hh:mm:ss");

  const diferencaEmAnos = moment().diff(data, "years");
  const diferencaEmMeses = moment().diff(data, "months");
  const diferencaEmSemanas = moment().diff(data, "weeks");
  const diferencaEmDias = moment().diff(data, "days");
  const diferencaEmHoras = moment().diff(data, "hours");
  const diferencaEmMinutos = moment().diff(data, "minutes");
  // Exibir o resultado

  if (diferencaEmAnos > 0) {
    return diferencaEmAnos === 1 ? "1 ano atrás" : `${diferencaEmAnos} anos atrás`;
  }

  if (diferencaEmMeses > 0) {
    return diferencaEmMeses === 1 ? "1 mês atrás" : `${diferencaEmMeses} meses atrás`;
  }

  if (diferencaEmSemanas > 0) {
    return diferencaEmSemanas === 1 ? "1 semana atrás" : `${diferencaEmSemanas} semanas atrás`;
  }

  if (diferencaEmDias > 0) {
    return diferencaEmDias === 1 ? "1 dia atrás" : `${diferencaEmDias} dias atrás`;
  }

  if (diferencaEmHoras > 0) {
    return diferencaEmHoras === 1 ? "1 Hora atrás" : `${diferencaEmHoras} horas atrás`;
  }

  if (diferencaEmMinutos > 0) {
    return diferencaEmMinutos === 1 ? "1 minuto atrás" : `${diferencaEmMinutos} minutos atrás`;
  }

  return "Alguns segundos atrás";
};

export const hideCPF = (cpf, forceHide = false) => {
  if (forceHide === false) {
    const client = JSON.parse(auth.getClient());
    if (client.disableLGPD) {
      return cpf;
    }
  }

  const str = toNumber(cpf).toString().padStart(11, "0");
  const newStrArr = [];
  for (let x = 0; x < str.length; x++) {
    if (x > 2 && x < 6) {
      newStrArr.push("*");
    } else if (x > 8) {
      newStrArr.push("*");
    } else {
      newStrArr.push(str[x]);
    }
  }
  return newStrArr.join("");
};

export const toNumber = (str) => {
  if (str) {
    return parseInt(str.toString().replace(/\D/g, ""));
  }
  return "";
};

export const msToSeconds = (str) => {
  if (str) {
    return parseInt(str.toString().replace(/\D/g, "")) / 1000 + "s";
  }
  return str;
};

export const toSimNao = (s) => {
  return s ? "Sim" : "Não";
};

export const slugToCamelCase = (str) => {
  const newStr = slugToPascalCase(str);
  return newStr.charAt(0).toLowerCase() + newStr.slice(1);
};

export const stringToSlug = (str,separator="-") => {
  const newStr = removeAccents(str).toLowerCase();
  return newStr.split(" ").join(separator);
};

export const removeAccents = (str) => {
  return str.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};


export const slugToPascalCase = (str) => {
  return str
    .toString()
    .toLowerCase()
    .split("-")
    .map((e) => e.charAt(0).toUpperCase() + e.slice(1))
    .join("");
};

export const formatCurrency = (value, thousands = true, prefix = "") => {
  if (value) {
    if (typeof value === "number") {
      value = value.toFixed(2).toString();
    }
    const signal = value.indexOf("-") !== -1 ? "-" : "";
    let newValue = value.replace(/\D/g, "");
    if (newValue === "") {
      newValue = "0";
    }
    if (newValue.length <= 4) {
      newValue = parseInt(newValue).toString();
    }
    newValue = newValue.padStart(3, "0");
    let decimals = newValue.substr(-2);
    let units = newValue.substr(0, newValue.length - 2);

    let unitsArr = [...units].reverse();
    let newUnitsArr = [];
    for (let x = 0; x < unitsArr.length; x++) {
      if (x > 0 && x % 3 === 0) {
        if (thousands) {
          newUnitsArr.push(".");
        }
      }
      newUnitsArr.push(unitsArr[x]);
    }

    const price = signal + newUnitsArr.reverse().join("") + "," + decimals;

    if (prefix) {
      return `${prefix} ${price}`;
    }

    return price;
  }

  if (prefix) {
    return `${prefix} 0,00`;
  }

  return "0,00";
};

export const formatPositiveCurrency = (value, thousands = true, prefix = "") => {
  if (value) {
    if (value < 0) {
      value = Math.abs(value); // Transforma valor negativo em positivo
    }

    if (typeof value === "number") {
      value = value.toFixed(2).toString();
    }

    let newValue = value.replace(/\D/g, "");
    if (newValue === "") {
      newValue = "0";
    }
    if (newValue.length <= 4) {
      newValue = parseInt(newValue).toString();
    }
    newValue = newValue.padStart(3, "0");
    let decimals = newValue.substr(-2);
    let units = newValue.substr(0, newValue.length - 2);

    let unitsArr = [...units].reverse();
    let newUnitsArr = [];
    for (let x = 0; x < unitsArr.length; x++) {
      if (x > 0 && x % 3 === 0) {
        if (thousands) {
          newUnitsArr.push(".");
        }
      }
      newUnitsArr.push(unitsArr[x]);
    }

    const price = newUnitsArr.reverse().join("") + "," + decimals;

    if (prefix) {
      return `${prefix} ${price}`;
    }

    return price;
  }

  if (prefix) {
    return `${prefix} 0,00`;
  }

  return "0,00";
};

export const currencyToFloat = (value) => {
  if (value) {
    value = value.toString();
    const signal = value.indexOf("-") !== -1 ? "-" : "";
    let newValue = value.replace(/\D/g, "");
    if (newValue === "") {
      newValue = "0";
    }
    if (newValue.length <= 4) {
      newValue = parseInt(newValue).toString();
    }
    newValue = newValue.padStart(3, "0");
    let decimals = newValue.substr(-2);
    let units = newValue.substr(0, newValue.length - 2);
    return parseFloat(`${signal}${units}.${decimals}`);
  }
};

export const toLink = (url) => {
  if (url && isUrl(url)) {
    return (
      <a href={url} target={"_blank"} rel="noreferrer noopenner">
        {url}
      </a>
    );
  }
  return url;
};

export const arrayToList = (arr) => {
  if (arr) {
    return arr.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <div>&bull; {item}</div>
        </React.Fragment>
      );
    });
  }
  return [];
};

export function mobileFormat(phone) {
  phone = phone.replace(/\D/g, "");
  const digits = [];
  for (let x = 0; x < phone.length; x++) {
    if (x === 0) {
      digits.push("(");
    }
    digits.push(phone[x]);
    if (x === 1) {
      digits.push(") ");
    }

    if (x === 6) {
      digits.push("-");
    }
  }
  return digits.join("");
  // return phone?.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
}

export function cpfFormat(document) {
  document = document.toString().replace(/\D/g, "").substr(-11).padStart(11, "0");
  const digits = [];
  for (let x = 0; x < document.length; x++) {
    digits.push(document[x]);
    if ([2, 5].includes(x)) {
      digits.push(".");
    }
    if ([8].includes(x)) {
      digits.push("-");
    }
  }
  return digits.join("");
}

export function cnpjFormat(document) {
  document = document.toString().replace(/\D/g, "").substr(-14).padStart(14, "0");
  const digits = [];
  for (let x = 0; x < document.length; x++) {
    digits.push(document[x]);
    if ([1, 4].includes(x)) {
      digits.push(".");
    }
    if ([7].includes(x)) {
      digits.push("/");
    }

    if ([11].includes(x)) {
      digits.push("-");
    }
  }
  return digits.join("");
}

export function cpfFormatMask(document) {
  document = document.toString().replace(/\D/g, "");
  const digits = [];
  for (let x = 0; x < document.length; x++) {
    digits.push(document[x]);
    if ([2, 5].includes(x)) {
      digits.push(".");
    }
    if ([8].includes(x)) {
      digits.push("-");
    }
  }
  return digits.join("");
}

export function cnpjFormatMask(document) {
  document = document.toString().replace(/\D/g, "");
  const digits = [];
  for (let x = 0; x < document.length; x++) {
    digits.push(document[x]);
    if ([1, 4].includes(x)) {
      digits.push(".");
    }
    if ([7].includes(x)) {
      digits.push("/");
    }

    if ([11].includes(x)) {
      digits.push("-");
    }
  }
  return digits.join("");
}

export const toIframe = (url) => {
  return <iframe className="noprint" src={url} allowFullScreen={false} frameBorder={0} title="PDF" width={"100%"} height={600}></iframe>;
};

export const toImg = (url) => {
  if(url && url !== "" && isUrl(url)){
    return <img src={url} alt="foto" width={"100%"} height={400} />;
  } else {
    return <h2><i className="fas fa-image"></i> Não disponível</h2>
  }
};
